import { memo, useState } from 'react'
import { CloseIcon, Input, Button, Text, Overlay } from '@pancakeswap/uikit'

import { InputModal, InputModalItem } from './style'

function App({ change, close }) {
  const [value, setValue] = useState('')
  const [iswaing, setIswaing] = useState(false)
  const valueChange = (e) => {
    setValue(e.target.value)
  }
  const btnClick = () => {
    close()
  }
  const sureHandler = () => {
    if (!value) {
      return
    }
    change(value)
    btnClick()
  }
  const onBlur = () => {
    value ? setIswaing(false) : setIswaing(true)
  }

  return (
    <Overlay>
      <InputModal>
        <InputModalItem className="flexsb">
          <Text fontSize="18px" bold>
            可自动在每个地址后面添加数量
          </Text>
          <CloseIcon onClick={btnClick} className="cursor" />
        </InputModalItem>
        <InputModalItem className="margintb1">自动添加数量</InputModalItem>
        <InputModalItem>
          <Input value={value} onChange={valueChange} className={`${iswaing ? 'borderred' : ''}`} onBlur={onBlur} />
        </InputModalItem>
        <InputModalItem className="flexend margint1">
          <Button onClick={btnClick}>关闭</Button>
          <Button className="marginl1" onClick={sureHandler}>
            确定
          </Button>
        </InputModalItem>
      </InputModal>
    </Overlay>
  )
}

export default memo(App)
